<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <button type="button" class="btn btn-outline-main btn-sm" @click="mtdVolver">
        <i class="fas fa-arrow-left"></i> Volver
      </button>
      <h5 class="ms-3 mb-0" style="color: #900052">
        <strong>AUDITORÍAS - {{ almacenName || "-" }}<span v-if="productName"> - {{ productName }}</span></strong>
      </h5>
    </div>

    <div v-if="loading" class="text-center py-3">Cargando...</div>
    <div v-else-if="dataAudit.length == 0" class="text-center py-3">
      Sin registros de auditoría para este almacén.
    </div>

    <table v-else class="table table-bordered border-main align-middle">
      <thead>
        <tr class="text-white text-center" style="background: #900052">
          <th scope="col">CANTIDAD</th>
          <th scope="col">CANTIDAD FÍSICA</th>
          <th scope="col">DIFERENCIA</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in dataAudit" :key="'audit_' + index" class="text-center">
          <td>{{ row.quantity }}</td>
          <td>{{ row.physical_quantity }}</td>
          <td>{{ row.difference_quantity }}</td>
        </tr>
      </tbody>
    </table>

    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

export default {
  name: "audit-stock",
  components: {
    SweetAlert,
  },
  props: {
    almacenId: {
      type: [Number, String],
      default: null,
    },
    almacenName: {
      type: String,
      default: "",
    },
    productDetailId: {
      type: [Number, String],
      default: null,
    },
    dispatchDetailId: {
      type: [Number, String],
      default: null,
    },
    productName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      swal: null,
      loading: false,
      dataAudit: [],
    };
  },
  watch: {
    almacenId: {
      immediate: true,
      handler() {
        this.mtdCheckAndFetch();
      },
    },
    productDetailId: {
      handler() {
        this.mtdCheckAndFetch();
      },
    },
    dispatchDetailId: {
      handler() {
        this.mtdCheckAndFetch();
      },
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdCheckAndFetch: function () {
      if (this.almacenId != null && this.productDetailId != null && this.dispatchDetailId != null) {
        this.mtdGetAudit();
      } else {
        this.dataAudit = [];
      }
    },
    mtdGetAudit: function () {
      this.loading = true;
      this.post({
        url: this.$store.getters.get__url + "/logistics/auditoriaAlmacen",
        token: this.$store.getters.get__token,
        params: {
          almacen: this.almacenId,
          product_detail_id: this.productDetailId,
          dispatch_detail_id: this.dispatchDetailId,
        },
      })
        .then((response) => {
          this.dataAudit = response.data;
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    mtdVolver: function () {
      this.$emit("volver");
    },
  },
};
</script>

<style scoped></style>